import {GlobalVariables} from "../GlobalVariables";
import {ScrollTrigger} from "../LibrariesImport";
import {gsap} from "../../lib/gsap";

export default class Footer {
    static init() {
        const footer = document.querySelector('.footer-main .footer-large-svg');
        if (footer) {


            ScrollTrigger.create({
                trigger: footer,
                start: 'top bottom',
                onEnter: () => {
                    const paths = footer.querySelectorAll('svg path');
                    paths.forEach((path, index) => {
                        gsap.fromTo(path, {
                            duration: 1,
                            opacity: 0,
                            y: 100,
                            ease: 'power4.out'
                        }, {
                            duration: 1,
                            opacity: 1,
                            y: 0,
                            ease: 'power4.out',
                            delay: index * 0.02

                        });
                    });
                }
            });

        }
    }
}